// 2027 coverage: IRS Rev. Proc. 2026-26 applicable percentages + 2026 HHS poverty guidelines
const FPL = { base: [15960, 5680], AK: [19950, 7100], HI: [18360, 6530] };
const BANDS = [[133, 150, 3.23, 4.3], [150, 200, 4.3, 6.78], [200, 250, 6.78, 8.66], [250, 300, 8.66, 10.22], [300, 400, 10.22, 10.22]];

const region = (zip) => {
  const p = Number(String(zip).slice(0, 3));
  if (p >= 995 && p <= 999) return "AK";
  if (p === 967 || p === 968) return "HI";
  return "base";
};

export const estimateSubsidy = ({ income, size, zip }) => {
  const inc = Number(income);
  if (!inc || inc <= 0 || !size) return null;
  const [first, add] = FPL[region(zip)];
  const fpl = first + add * (size - 1);
  const pct = (inc / fpl) * 100;
  if (pct < 100) return { pct, fpl, status: "medicaid" };
  if (pct > 400) return { pct, fpl, status: "over" };
  let rate = 2.15;
  const band = BANDS.find(([lo, hi]) => pct >= lo && pct < hi) || (pct >= 300 ? BANDS[4] : null);
  if (band) {
    const [lo, hi, a, b] = band;
    rate = a + ((b - a) * (Math.min(pct, hi) - lo)) / (hi - lo);
  }
  return { pct, fpl, rate, monthly: (inc * rate) / 100 / 12, status: pct < 138 ? "maybe-medicaid" : "eligible" };
};
